import { useMutation } from '@tanstack/react-query';
import type {
	LWApiPublicSupportRequestAuthenticateParamsRawI,
	LWApiPublicSupportRequestAuthenticateResultRawI,
} from '@liquidweb-dev/club-sauce/public/support/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useSupportRequestAuthenticate = () => {
	const snackbarError = useSnackbarError('Error authenticating');

	return useMutation<
		LWApiPublicSupportRequestAuthenticateResultRawI,
		ApiErrorI,
		LWApiPublicSupportRequestAuthenticateParamsRawI
	>({
		mutationFn: (params) => api.support.request.apiRaw.authenticate(params),

		onError: snackbarError,
	});
};

export default useSupportRequestAuthenticate;
